import { toast } from 'react-toastify'
import * as types from './types'
import * as integration from '../../../integration'

export const receive = (type, value) => ({
  type,
  payload: value
})

export const fetch = (type, payload = true) => ({
  type,
  payload
})

export const clearExtract = () => ({
  type: types.CLEAR_EXTRACT
})

export const clearExtractLevelThree = () => ({
  type: types.CLEAR_EXTRACT_LEVEL_THREE
})

export const handleFilterManagements = (categoryId) => (dispatch, getState) => {
  const { indicators: { managements } = {} } =
    getState()?.extractReducer?.extract

  let currentExtracts = []

  if (categoryId === 0) {
    currentExtracts = managements
  } else {
    currentExtracts = managements?.filter(
      (management) => management?.categoryId === categoryId
    )
  }

  dispatch(receive(types.RECEIVE_CURRENT_EXTRACTS, currentExtracts))
}

export const getExtract =
  (id, params = {}) =>
  async (dispatch, getState) => {
    dispatch(clearExtract())
    dispatch(fetch(types.FETCH_EXTRACT))

    try {
      const res =
        await integration.resources.extract.requests.getExtractResource(
          id,
          params
        )

      window.gtag('event', 'select_content', {
        content_type: 'wallet extract',
        item_id: id
      })

      dispatch(receive(types.RECEIVE_EXTRACT, res))
    } catch (err) {
      toast(
        'As informações para o período selecionado ainda não foram atualizadas.',
        {
          type: 'warning',
          progress: false
        }
      )

      const { lastPeriodWithData } = getState()?.extractReducer

      const res =
        await integration.resources.extract.requests.getExtractResource(id, {
          year_month: lastPeriodWithData
        })

      dispatch(fetch(types.RECEIVE_EXTRACT, res))
    }
  }

export const getExtractLeveTwo = (storeTabNumber, id) => async (dispatch) => {
  dispatch(fetch(types.FETCH_EXTRACT))

  try {
    const res =
      await integration.resources.extract.requests.getExtractLevelTwoResource(
        storeTabNumber,
        id
      )

    dispatch(receive(types.RECEIVE_EXTRACT_LEVEL_TWO, res))
  } catch (err) {
    // tratar erro
    dispatch(fetch(types.FETCH_EXTRACT_LEVEL_TWO, false))
  }
}

export const getExtractLevelThree =
  (storeTabNumber, id, itemSelected) => async (dispatch) => {
    dispatch(fetch(types.FETCH_EXTRACT_LEVEL_THREE))

    try {
      const res =
        await integration.resources.extract.requests.getExtractLeveThree(
          storeTabNumber,
          id,
          itemSelected
        )

      dispatch(receive(types.RECEIVE_EXTRACT_LEVEL_THREE, res))
    } catch (err) {
      dispatch(fetch(types.FETCH_EXTRACT_LEVEL_THREE, false))
    }
  }

export const handleCurrentExtract = (currentExtract) => async (dispatch) => {
  dispatch(receive(types.RECEIVE_CURRENT_EXTRACT, currentExtract))
}

export const receiveProduct = (payload) => ({
  type: types.RECEIVE_PRODUCT,
  payload
})
